export const LABELS_MAP = {
  ORIGINAL: 'Original Resolution',
  HD: 'High Resolution',
  SD: 'Low Resolution',
  CAPTION: 'Captions SRT',
  VTT_CAPTION: 'Captions VTT'
};